<template>
  <div>
    <pv-data-info-box
      v-for="dataset in datasets"
      :key="dataset.id"
      :to="`/datasets/${dataset.id}?locale=${locale}`"
      :src="getImg(getCatalogImage(dataset.catalog))"
      scope="Dataset"
      :origin="dataset.country?.label"
      :dataset="{
        title:
          getTranslationFor(dataset.title, locale, dataset.languages) ||
          dataset.id,
        description: getTranslationFor(
          dataset.description,
          locale,
          dataset.languages,
        ),
        catalog: getTranslationFor(dataset.catalog.title, locale, []),
        createdDate: dataset.releaseDate,
        updatedDate: dataset.modificationDate,
        formats: removeDuplicatesOf(dataset.distributionFormats || []).filter(
          (format) => format.id || format.label,
        ),
      }"
      :description-max-length="1000"
      :data-cy="`dataset@${dataset.id}`"
      class="mt-3"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { helpers } from "@piveau/piveau-hub-ui-modules";
import { groupBy, has, toPairs, uniqBy } from "lodash-es";
import axios from "axios";
import { isUnavailableDatasetId } from "@/utils/unavailableDatasets";

const { getImg, getTranslationFor, truncate } = helpers;

export default {
  name: "DatasetsList",
  computed: {
    ...mapGetters("datasets", ["getDatasets"]),
    ...mapGetters("search", ["getLikedDatasets"]),
    locale() {
      return this.$route.query.locale;
    },
    datasets() {
      const filterUnavailable = (items) =>
        (items || []).filter((dataset) => !isUnavailableDatasetId(dataset?.id));

      if (this.dssId) {
        return filterUnavailable(this.cachedDatasets);
      } else if (this.$route?.query?.mostLiked) {
        return filterUnavailable(this.getLikedDatasets);
      }
      return filterUnavailable(this.getDatasets);
    },
  },
  data() {
    return {
      cachedDatasets: [],
      datasetsLoading: false,
    };
  },
  props: {
    dssId: {
      type: String,
      default: null,
      required: false,
    },
  },
  watch: {
    dssId(newVal) {
      if (newVal) {
        this.fetchDatasetsByDssId(newVal);
      }
    },
  },
  mounted() {
    if (this.dssId) {
      this.fetchDatasetsByDssId(this.dssId);
    }
  },
  methods: {
    getImg,
    getTranslationFor,
    truncate,
    getCatalogImage(catalog) {
      const countryId = catalog?.country?.id?.toLowerCase() === "europe"
        ? "eu"
        : catalog?.country?.id;
      return this.$env.content.catalogs.useCatalogCountries
        ? `${this.$env.content.catalogs.defaultCatalogImagePath}/${
            countryId
              ? countryId
              : this.$env.content.catalogs.defaultCatalogCountryID
          }`
        : `${this.$env.content.catalogs.defaultCatalogImagePath}/${
            has(catalog, "id")
              ? catalog.id
              : this.$env.content.catalogs.defaultCatalogID
          }`;
    },
    async fetchDatasetsByDssId(dssId) {
      if (!dssId || this.datasetsLoading) return;
      this.datasetsLoading = true;

      try {
        const endpoint = `${this.$env.api.baseUrl}search`;
        const params = {
          filter: "dataset",
          facets: JSON.stringify({ in_series: [dssId] }),
        };

        const res = await axios.get(endpoint, { params });
        console.log("Fetched datasets for DSS ID:", res.data);
        this.cachedDatasets = res?.data?.result.results || [];
      } catch (err) {
        console.error("Failed to fetch datasets by DSS ID:", err);
        this.cachedDatasets = [];
      } finally {
        this.datasetsLoading = false;
      }
    },
    removeDuplicatesOf(array) {
      const correctedFormatArray = array.map((format) => ({
        ...format,
        id: this.getBadgeFormat(format.id),
        label: this.getBadgeFormat(format.label),
      }));
      const sortedArray = toPairs(groupBy(correctedFormatArray, "id")).sort(
        (a, b) => b[1].length - a[1].length,
      );
      const onlyFormatObjectsArray = sortedArray.map((arr) => arr[1][0]);
      const uniqById = uniqBy(onlyFormatObjectsArray, "id");
      return uniqBy(uniqById, "label");
    },
    getBadgeFormat(label) {
      return this.truncate(label, 8, true);
    },
  },
};
</script>